/**
 * Plain-language captions for Drive metric chrome (summary tiles, watch strips).
 * Interim until view-definition / reporting copy is authored per company.
 */

export type DriveMetricCaption = {
  label: string;
  title: string;
};

export const DRIVE_SUMMARY_CAPTIONS: Record<string, DriveMetricCaption> = {
  in_flow: {
    label: 'Moving',
    title: 'Work items currently in an active flow stage for this period window.',
  },
  movedRecently: {
    label: 'Moved',
    title: 'Work that advanced a stage recently in this period window.',
  },
  blocked: {
    label: 'Held',
    title: 'Work waiting on a blocker, approval, or unhealthy stage.',
  },
  expectedToMove: {
    label: 'Expected',
    title: 'Work the period plan expects to move before the window ends.',
  },
  parked: {
    label: 'Parked',
    title: 'Work set aside outside the main flow stages.',
  },
  dwell: {
    label: 'Longest wait',
    title: 'Highest average stage wait time in the current flow board.',
  },
};

export function driveSummaryCaption(key: string): DriveMetricCaption {
  return (
    DRIVE_SUMMARY_CAPTIONS[key] || {
      label: key,
      title: 'Drive period metric for the selected scope.',
    }
  );
}

/** Watch-strip rev/cost — period rollup facts, not a full P&L report. */
export function formatWatchRollupMeta(parts: {
  occupancy?: string | null;
  revenueActual?: number | null;
  costActual?: number | null;
}): string | null {
  const bits: string[] = [];
  if (parts.occupancy) bits.push(parts.occupancy);
  if (parts.revenueActual != null) bits.push(`period value ${parts.revenueActual}`);
  if (parts.costActual != null) bits.push(`period cost ${parts.costActual}`);
  return bits.length ? bits.join(' · ') : null;
}

export const WATCH_ROLLUP_TITLE =
  'Period rollup from the subdomain reporting-period container (value generated / cost), not a selectable business report.';
